// Scan ACC Adit: RINCIAN BARANG — HASIL AI (mockup final tersimpan, tanpa SKU) + Perbaiki Rincian sebelum ACC.
import React, { useState } from "react";

const SLEEVES = [["pendek", "Pendek"], ["panjang", "Panjang"], ["tidak_berlaku", "Tidak Berlaku"]];
const SL_LABEL = Object.fromEntries(SLEEVES);
const EMPTY = { product: "", color: "", sleeve: "pendek", size: "", qty: 1 };
const pick = (r) => ({ product: r.product || "", color: r.color || "", sleeve: r.sleeve || "", size: r.size || "", qty: r.qty ?? "" });

export const rowsComplete = (rows) => rows.length > 0 && rows.every(r =>
  String(r.product).trim() && String(r.color).trim() && String(r.size).trim() && r.sleeve && Number(r.qty) > 0 && Number.isInteger(Number(r.qty)));

// Nilai awal per unit ACC: hasil AI lengkap = siap dikonfirmasi; tidak lengkap = perlu diisi/diperbaiki Adit.
export const initialVal = (det) => ({ rows: (det?.rows || []).map(pick), edited: false });

// Body ACC per unit: kirim rincian hanya bila AI lengkap ATAU Adit sudah memperbaiki & lengkap. Selain itu → Perlu Verifikasi Manual.
export function verifiedBody(det, val) {
  if (!val) return {};
  if (val.edited) return rowsComplete(val.rows) ? { verified_lines: val.rows.map(r => ({ ...r, qty: Number(r.qty) })), lines_edited: true } : {};
  return det?.complete ? { verified_lines: val.rows.map(r => ({ ...r, qty: Number(r.qty) })), lines_edited: false } : {};
}

export function AiDetails({ unitKey, title, det, val, onChange, locked }) {
  const [edit, setEdit] = useState(false);
  if (!det) return null;
  const rows = val?.rows || [];
  const ok = val?.edited ? rowsComplete(rows) : det.complete;
  const total = rows.reduce((n, r) => n + (Number(r.qty) || 0), 0);
  const set = (rs) => onChange({ rows: rs, edited: true });
  const upd = (i, k, v) => set(rows.map((r, j) => j === i ? { ...r, [k]: v } : r));
  return <div className={`afs-ai ${ok ? "ok" : "warn"}`} data-testid={`acc-ai-${unitKey}`}>
    <div className="afs-ai-head">RINCIAN BARANG — {val?.edited ? "DIPERBAIKI ADIT" : "HASIL AI"}{title ? ` · ${title}` : ""}</div>
    {!ok && <div className="afs-ai-warn" data-testid={`acc-ai-incomplete-${unitKey}`}>
      Data Barang Belum Lengkap{!val?.edited && det.reason ? ` — ${det.reason}` : ""}. Isi lewat Perbaiki Rincian, atau ACC tetap jalan dan stok ditandai Perlu Verifikasi Manual.</div>}
    {!edit && rows.map((r, i) => <div key={i} className="afs-ai-row" data-testid={`acc-ai-row-${unitKey}-${i}`}>
      <span><em>Produk</em> {r.product || "—"}</span><span><em>Warna</em> {r.color || "—"}</span>
      <span><em>Lengan</em> {SL_LABEL[r.sleeve] || r.sleeve || "—"}</span><span><em>Ukuran</em> {r.size || "—"}</span>
      <span><em>Jumlah</em> <b>{r.qty || 0} pcs</b></span>
      {!val?.edited && det.rows?.[i]?.match_note && <span className="afs-ai-note" data-testid={`acc-ai-note-${unitKey}-${i}`}>{det.rows[i].match_note}</span>}
    </div>)}
    {edit && <div className="afs-ai-edit" data-testid={`acc-ai-editor-${unitKey}`}>
      {rows.map((r, i) => <div key={i} className="afs-ai-erow">
        <input value={r.product} onChange={e => upd(i, "product", e.target.value)} placeholder="Produk" aria-label="Produk" data-testid={`acc-ai-in-product-${unitKey}-${i}`}/>
        <input value={r.color} onChange={e => upd(i, "color", e.target.value)} placeholder="Warna" aria-label="Warna" data-testid={`acc-ai-in-color-${unitKey}-${i}`}/>
        <select value={r.sleeve} onChange={e => upd(i, "sleeve", e.target.value)} aria-label="Lengan" data-testid={`acc-ai-in-sleeve-${unitKey}-${i}`}>
          <option value="">Lengan…</option>{SLEEVES.map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select>
        <input value={r.size} onChange={e => upd(i, "size", e.target.value)} placeholder="Ukuran" aria-label="Ukuran" data-testid={`acc-ai-in-size-${unitKey}-${i}`}/>
        <input type="number" min="1" inputMode="numeric" value={r.qty} onChange={e => upd(i, "qty", e.target.value)} aria-label="Jumlah" data-testid={`acc-ai-in-qty-${unitKey}-${i}`}/>
        <button type="button" onClick={() => set(rows.filter((_, j) => j !== i))} aria-label="Hapus baris" data-testid={`acc-ai-del-${unitKey}-${i}`}>×</button>
      </div>)}
      <button type="button" onClick={() => set([...rows, { ...EMPTY }])} data-testid={`acc-ai-add-${unitKey}`}>+ Tambah Baris</button>
    </div>}
    <div className="afs-ai-foot">
      <span data-testid={`acc-ai-total-${unitKey}`}>Total pakaian: <b>{total} pcs</b></span>
      {det.cut?.status && <span className="afs-ai-cut" data-testid={`acc-ai-cut-${unitKey}`}>Stok: {det.cut.label}{det.cut.doc_number ? ` (${det.cut.doc_number})` : ""}</span>}
      {!locked && <button type="button" className="afs-ai-fix" onClick={() => setEdit(x => !x)} data-testid={`acc-ai-fix-${unitKey}`}>{edit ? "Selesai" : "Perbaiki Rincian"}</button>}
    </div>
  </div>;
}

// Konfirmasi Rincian untuk ACC yang sudah terjadi (stok belum dipotong). Cek fisik wajib; server mencegah potong ganda.
export function ConfirmCut({ unitKey, cutKey, det, val, onDone, post }) {
  const [ok, setOk] = useState(false), [busy, setBusy] = useState(false), [msg, setMsg] = useState("");
  const body = verifiedBody(det, val);
  const ready = !!body.verified_lines;
  const go = async () => {
    setBusy(true); setMsg("");
    try { const r = await post({ key: cutKey, ...body, physical_check: true }); setMsg(r?.message || "Tersimpan"); onDone(); }
    catch (e) { setMsg(e?.response?.data?.detail || "Gagal konfirmasi"); }
    setBusy(false);
  };
  return <div className="afs-ai-confirm" data-testid={`acc-confirm-${unitKey}`}>
    <label><input type="checkbox" checked={ok} onChange={e => setOk(e.target.checked)} data-testid={`acc-confirm-check-${unitKey}`}/>
      {" "}Saya sudah memeriksa fisik produk, warna, ukuran, lengan, dan jumlah</label>
    {!ready && <div className="afs-ai-warn">Rincian belum lengkap — gunakan Perbaiki Rincian dahulu.</div>}
    <button type="button" className="afs-ai-fix" disabled={!ok || !ready || busy} onClick={go} data-testid={`acc-confirm-btn-${unitKey}`}>
      {busy ? "Menyimpan…" : "Konfirmasi Rincian"}</button>
    {msg && <div className="afs-ai-cut" data-testid={`acc-confirm-msg-${unitKey}`}>{msg}</div>}
  </div>;
}

